// Paging arithmetic.

export const pageCount = (total, pageSize) =>
  Math.max(1, Math.ceil((total || 0) / pageSize))

const wholePage = page => Math.max(1, Math.trunc(page) || 1)

/**
 * Clamps a page into the range a count allows. A count is only evidence once it is known: while rows load
 * or fail, the set is empty because nothing has arrived, so the page stays where it is and Retry returns to
 * it. Without `known`, a positive count is taken as known and a zero count as not yet known.
 * @param {number} page
 * @param {number} total
 * @param {number} pageSize
 * @param {boolean} [known]
 */
export const clampPage = (page, total, pageSize, known = total > 0) =>
  known
    ? Math.min(wholePage(page), pageCount(total, pageSize))
    : wholePage(page)

export const pageRows = (rows, page, pageSize) =>
  rows.slice((page - 1) * pageSize, page * pageSize)

// 1-based first and last shown positions; 0 and 0 when nothing matches
export const shownRange = (total, page, pageSize) => ({
  firstShown: total ? (page - 1) * pageSize + 1 : 0,
  lastShown: Math.min(total, page * pageSize),
})
